import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";
import BranchTicketsPerServiceReport from "../../../components/branches/reports/daily/BranchTicketsPerService";
import _ from "lodash";

const BranchTicketsPerService = ({
  showFilterForm = true,
  reportIndex = 1,
}) => {
  const { reportRange, loading, tickets, branches, organizationId, branchId } =
    useSelector((state) => state.defaultReducer);
  let branchesClone = _.cloneDeep(branches);
  branchesClone = branchesClone
    .filter(
      (a) =>
        a.reportStatus != null &&
        Number(a.reportStatus) &&
        a.organizationId === organizationId
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));
  const reportTitle = `${reportIndex}. Tickets Per Service`;
  console.log(reportTitle);
  return (
    <Box>
      {
        // create a page break if this is not the first report
        Number(reportIndex) !== 1 ? (
          <Box className="forcePageBreak"></Box>
        ) : null
      }
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{reportTitle}</h1>
              <p className="reportDescription">
                {getReportDescription(reportRange).TicketsPerServiceBranches}
              </p>

              {branchesClone?.map((a, i) => {
                return (
                  <BranchTicketsPerServiceReport
                    key={a.id}
                    reportIndex={reportIndex}
                    branchId={a.id}
                    branchIndex={i + 1}
                  />
                );
              })}
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default BranchTicketsPerService;
